export default __webpack_public_path__ + "static/media/agent-login.9a3c5254.png";